import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import Div100vh from 'modules/utils/cp3/components/Div100vh';
import { LOGIN_MANAGE_URL } from 'utils/constants';
import { cookiesHelper, getLanguageCode } from 'modules/utils';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import { AuthProvider } from './context';
import LoginForm from './LoginForm';
import PasswordResetForm from './PasswordResetForm';
import LandingResetForm from './LandingResetForm';
import RefreshPage from './RefreshPage';
import SideBar from './sharedComponents/SideBar';
import MobileWrapper from './sharedComponents/MobileWrapper';
import MapSection from './sharedComponents/MapSection';
import MobileLogin from './MobileLogin';

const propTypes = {
	logout: PropTypes.func,
	width: PropTypes.string,
};

const Authentication = ({ logout, width }) => {
	return (
		<AuthProvider>
			<IntlProvider
				locale={
					cookiesHelper.get('CP4_LOCALE') || getLanguageCode(navigator.language)
				}
				defaultLocale="en"
			>
				<Div100vh>
					{isWidthDown('xs', width) ? (
						<MobileWrapper>
							<Switch>
								<Route
									path="/login"
									render={() => <MobileLogin logout={logout} />}
								/>
								<Route
									path="/password_reset"
									render={props => <PasswordResetForm {...props} />}
								/>
								<Route
									path="/reset_password"
									render={props => <LandingResetForm {...props} />}
								/>
								<Route
									path="/refresh_page"
									render={props => <RefreshPage {...props} />}
								/>
								<Route
									path="/manage"
									render={props => (
										<LoginForm
											{...props}
											loginUrl={LOGIN_MANAGE_URL}
											title="loginManageTitle"
											isAdmin
										/>
									)}
								/>
							</Switch>
						</MobileWrapper>
					) : (
						<>
							<SideBar>
								<Switch>
									<Route
										path="/login"
										render={() => <LoginForm logout={logout} />}
									/>
									<Route
										path="/manage"
										render={props => (
											<LoginForm
												{...props}
												loginUrl={LOGIN_MANAGE_URL}
												title="loginManageTitle"
												isAdmin
											/>
										)}
									/>
									<Route path="/password_reset" component={PasswordResetForm} />
									<Route path="/reset_password" component={LandingResetForm} />
									<Route path="/refresh_page" component={RefreshPage} />
								</Switch>
							</SideBar>
							<MapSection />
						</>
					)}
				</Div100vh>
			</IntlProvider>
		</AuthProvider>
	);
};

Authentication.propTypes = propTypes;

export default withWidth()(Authentication);
